import type { AchordData } from "src/app";

export type Profiles = {
	[key: string]: AchordData.Profile;
}


const profiles: Profiles = {
	'sys': {
		name: 'busystems',
		avatar: 'busystems',
		online: false,
	},
	'biz': {
		name: 'BizMan',
		avatar: 'bizman',
		online: false,
	},
	'dev': {
		name: 'the_beard',
		avatar: 'devbeard96',
		online: false,
	},
	'captain': {
		name: 'Captain Shiphard',
		avatar: 'captainshiphard',
		online: false,
	},
	'sil': {
		name: 'Sil',
		avatar: 'sil',
		online: false,
	},
	'chill': {
		name: 'ChillBeets',
		avatar: 'chillbeets',
		online: false,
	},
	'unklear': {
		name: 'unklear',
		avatar: 'dog',
		online: false,
	},
}

const guests: Profiles = {
	'guest': {
		name: 'Guest',
		avatar: 'abstract',
		online: false,
	},
	'guest2': {
		name: 'Guest 2 ',
		avatar: 'abstract2',
		online: false,
	},
	'guest3': {
		name: 'Guest 3',
		avatar: 'abstract3',
		online: false,
	}
}

const bots: Profiles = {
	'bot': {
		name: 'Dumb Test Bot',
		avatar: 'abstract',
		online: false,
		hidden: true,
	},
	'dadbot': {
		name: 'Dad Joke Bot',
		avatar: 'dad-bot',
		online: false,
		hidden: true,
	},
	'stoicism': {
		name: 'Stoic',
		avatar: 'stoicism-bot',
		online: false,
		hidden: true,
	},
	'comedian': {
		name: 'Comedian',
		avatar: 'comedian-bot',
		online: false,
		hidden: true,
	}
}

const all = { ...profiles, ...guests, ...bots };

function sortByAuthorName(a: AchordData.Profile, b: AchordData.Profile) {
	return a.name.localeCompare(b.name);
}

function sortByOnline(a: AchordData.Profile, b: AchordData.Profile) {

	if (a.online && !b.online) {
		return -1;
	}

	return 0;
}

export function getActiveProfiles(activeNames: string[]) {
	return Object.values(profiles).map((profile: AchordData.Profile): AchordData.Profile => {
		return {
			...profile,
			online: activeNames.includes(profile.name),
		}
	}).sort(sortByAuthorName).sort(sortByOnline);
}

export function getProfiles(names: string[]): AchordData.Profile[] {
	return names.map(getProfile);
}

export function getProfile(id: string): AchordData.Profile {
	return all[id];
}

export function getRandomGuest(): AchordData.Profile {
	const keys = Object.keys(guests);
	const index = Math.floor(Math.random() * keys.length);
	return guests[keys[index]];
}